import { translate } from '@jsverse/transloco';
export enum ProductEnum {
    ALL = 'ALL',
    CCS = 'CCS',
    MSS = 'MSS',
    MST_MCS = 'MST/MCS',
    PORTAL = 'PORTAL',
    VULNERABILITY_MANAGEMENT = 'Vulnerability Management',
}

export abstract class ProductEnumHelper {
    static getProductIcon(product: ProductEnum): string {
        switch (product) {
            case ProductEnum.ALL:
                return 'notifications';
            case ProductEnum.CCS:
                return 'edit_document';
            case ProductEnum.MSS:
                return 'security';
            case ProductEnum.MST_MCS:
                return 'assignment';
            case ProductEnum.VULNERABILITY_MANAGEMENT:
                return 'network_check';
            case ProductEnum.PORTAL:
                return 'dashboard';
            default:
                return 'notifications';
        }
    }

    static getProductLabel(product: ProductEnum): string {
        switch (product) {
            case ProductEnum.ALL:
                return translate('CORE.NOTIFICATION_HISTORY.ALL_NOTIFICATIONS');
            case ProductEnum.CCS:
                return translate('CORE.NOTIFICATION_HISTORY.CCS');
            case ProductEnum.MSS:
                return translate('CORE.NOTIFICATION_HISTORY.MSS');
            case ProductEnum.MST_MCS:
                return translate('CORE.NOTIFICATION_HISTORY.ASSESSMENT');
            case ProductEnum.VULNERABILITY_MANAGEMENT:
                return translate('CORE.NOTIFICATION_HISTORY.VULNERABILITY_SCANNING');
            case ProductEnum.PORTAL:
                return translate('CORE.NOTIFICATION_HISTORY.PORTAL');
            default:
                return '';
        }
    }
}
